import getCurrentUid from './getCurrentUid'

// TODO: refactor anything calling this
const addUidToObject = (obj) => {
	const uid = getCurrentUid()
	return !uid || uid === 'undefined' || uid === 'null' ? { ...obj } : { ...obj, uid }
}

export default addUidToObject



// WEBPACK FOOTER //
// ./src/utilities/addUidToObject.js